// @flow

export default {
  'rgb(174, 174, 174)': 'Fold',
  'rgb(102, 150, 53)': 'Call/Check',
  'rgb(252, 209, 145)': 'Limp Call',
  'rgb(138, 120, 191)': 'Limp Fold',
  'rgb(246, 147, 120)': 'Limp Reraise',
  'rgb(246, 171, 42)': 'Raise Call',
  'rgb(89, 57, 185)': 'Raise Fold',
  'rgb(255, 95, 95)': 'Raise Reraise',
  'rgb(47, 80, 14)': 'Call Call',
  'rgb(155, 210, 98)': 'Call Fold',
  'linear-gradient(180deg, rgb(255, 95, 95) 50%, rgb(102, 150, 53) 50%)': 'Call Raise',
  'linear-gradient(180deg, rgb(102, 150, 53) 50%, rgb(255, 95, 95) 50%)': 'Raise Reraise Call',
  'linear-gradient(180deg, rgb(89, 57, 185) 50%,rgb(255, 95, 95) 50%)': 'Raise Reraise Fold',
  'linear-gradient(180deg, rgb(255, 23, 56) 50%, rgb(255, 95, 95) 50%)': 'Raise Reraise Reraise',
  'linear-gradient(180deg, rgb(102, 150, 53) 50%, rgb(246, 147, 120) 50%)': 'Limp Reraise Call',
  'linear-gradient(180deg, rgb(89, 57, 185) 50%, rgb(246, 147, 120) 50%)': 'Limp Reraise Fold',
  'linear-gradient(180deg, rgb(255, 23, 56) 50%, rgb(246, 147, 120) 50%)': 'Limp Reraise Reraise',
};
